// Rede de segurança contra promises que nunca resolvem NEM rejeitam.
//
// No totem, uma promise pendurada não é um erro: é a tela congelada. O
// `vTimeout` não salva, porque ele só arma após 20s sem nenhum evento de mouse
// — e um cliente cutucando a tela travada impede o AFK de disparar. Toda
// chamada de rede que bloqueia o avanço de uma etapa precisa de um limite.

export const TIMEOUT_PADRAO_MS = 15000;

export class TimeoutError extends Error {
  constructor(rotulo, ms) {
    super(`Timeout de ${ms}ms excedido em: ${rotulo}`);
    this.name = "TimeoutError";
    this.isTimeout = true;
    this.rotulo = rotulo;
  }
}

// Corre a promise contra um limite de tempo. O timer é sempre limpo, para não
// segurar a thread viva depois que a promise original resolveu.
export function comTimeout(promise, opcoes = {}) {
  const ms = opcoes.ms || TIMEOUT_PADRAO_MS;
  const rotulo = opcoes.rotulo || "operação";

  let timer = null;
  const limite = new Promise((_, reject) => {
    timer = setTimeout(() => reject(new TimeoutError(rotulo, ms)), ms);
  });

  return Promise.race([promise, limite]).finally(() => {
    if (timer) clearTimeout(timer);
  });
}
